
export const update_app_loader = "update_app_loader";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const CATEGORIES_LOADED = "CATEGORIES_LOADED";
export const SET_HOME_BRAND_ID = 'SET_HOME_BRAND_ID';
export const update_cart_display_status = "update_cart_display_status";
export const update_auth_modal_display_status = "update_auth_modal_display_status";
export const add_to_cart = "add_to_cart";
export const remove_from_cart = "remove_from_cart";
export const fetch_cart = "fetch_cart";
export const set_cart = "set_cart";
export const request_add_to_cart = "request_add_to_cart";
export const recalculate_cart_total = "recalculate_cart_total";
export const requist_cart_total = "requist_cart_total";
export const show_header_cart = "show_header_cart";
export const GET_TAX_AND_DELIEVERY = "GET_TAX_AND_DELIEVERY";
export const SET_ORDER_TAX_DELIEVERY = "SET_ORDER_TAX_DELIEVERY";
export const set_active_location = "set_active_location";
export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const SET_REDIRECT = "SET_REDIRECT";
export const update_add_address_modal_display_status = "update_add_address_modal_display_status";
export const Toggle_Wallet_Display_Status = "Toggle_Wallet_Display_Status";
export const GET_USER_WALLETS = 'GET_USER_WALLETS';
export const SET_USER_WALLETS = 'SET_USER_WALLETS';
export const GET_USER_CREDIT = 'GET_USER_CREDIT';
export const SET_USER_CREDIT = 'SET_USER_CREDIT';
export const request_paymob_iframe = 'request_paymob_iframe';
export const get_paymob_iframe = 'get_paymob_iframe';
export const set_delivery_type = 'set_delivery_type';
export const set_website_attributes = 'set_website_attributes';
export const GetSliders = 'GetSliders';
export const SlidersLoaded = 'SlidersLoaded';
export const GetSubCategories = 'GetSubCategories';
export const SubCategoriesLoaded = 'SubCategories';
export const GetHotDealsData = 'GetHotDealsData';
export const HotDealsDataLoaded = 'HotDealsDataLoaded';
export const GetCategoriesata = 'GetCategoriesata';
export const CategoriesLoaded = 'CategoriesLoaded';
export const GetBrandsData = 'GetBrandsData';
export const BrandsLoaded = 'BrandsLoaded';

